module.exports = __webpack_public_path__ + "static/media/Post_Before.8a98e9ef.jpg";